export default {
  title: "Mijozlar ro‘yxati",
  allClients: "Barcha mijozlar",
  internalClients: "Ichki",
  internalClient: "Ichki",
  externalClients: "Tashqi",
  externalClient: "Tashqi",
  clientsType: "Mijoz turi",

  noEnitity: {
    label: "Sahifa mavjud emas",
    text: "Sizning yuridik shaxsingiz moderatsiyada",
  },
  needBuyTariff: "Mijozlarni raqamlashtirish uchun tarif sotib olish kerak",
  noTradingPoint: "Sizda hali savdo nuqtalari yo‘q",
  digitizeClients:
    "Mijozlarni raqamlashtiring, ular ro‘yxatingizda ko‘rsatiladi",

  table: {
    inviteDate: "Ro‘yxatdan o‘tgan sana",
    fullName: "F.I.Sh.",
    phone: "Telefon raqami",
    receiptsCount: "Sotib olishlar soni",
    receiptsSum: "Sotib olish summasi",
  },

  clientCard: {
    title: "Mijoz haqida ma’lumot",
    client: {
      title: "Mijoz",
      fields: {
        fullName: "F.I.Sh.",
        gender: "Jinsi",
        birthDate: "Tug‘ilgan sana",
        phone: "Telefon raqami",
        clientType: "Mijoz turi",
        inviteDate: "Ro‘yxatdan o‘tgan sana",
        regSource: "Ro‘yxatdan o‘tgan manba",
        rcCard: "RC karta raqami",
        note: "Izoh",
      },
      phoneHint:
        "Telefon raqami faqat pullik tariflarda va kontakt ma’lumotlarini berishga va marketing takliflarini olishga rozilik bergan mijozlar uchun ko‘rsatiladi.",
    },
    statistic: {
      title: "Statistika",
      block: {
        avgReceiptsSum: "O‘rtacha chek",
        receiptsCount: "Sotib olishlar soni",
        receiptsSum: "Aylanish",
        writeOffPointsSum: "Ballar bilan to‘lov",
      },
      totalNumberOfVisit: "Umumiy tashriflar soni",
      firstVisit: "Birinchi tashrif",
      lastVisit: "So‘nggi tashrif",
      visitedShops: "Tashrif buyurilgan joylar",
    },
    receipts: {
      title: "Cheklar",
      emptyState: {
        title: "Cheklar mavjud emas",
        description: "Ular mijoz xarid qilgandan so‘ng bu yerda paydo bo‘ladi",
      },
    },
    reviews: {
      title: "Sharhlar",
      noReviews: "Hali sharhlar yo‘q",
      itsAppearHere: "Mijoz sharh qoldirganda ular bu yerda ko‘rinadi",
    },
  },
  pointsAwarded: "Ballar hisobga olindi",
  digitizingOnYourTariffNotAvailable:
    "Sizning tarifingizda mijozlarni raqamlashtirish mavjud emas",
  digitizingIntoRC: "Mijozlarni raqamlashtirish<br> RC PAY orqali",
  fastDigitizingIntoTg: "Tezkor raqamlashtirish<br> Telegram-bot orqali",
  abilityToUseLinkOrQRcode:
    "Yangi foydalanuvchilarni taklif qilish uchun havola yoki QR-koddan foydalanish imkoniyati tarif sotib olingandan keyin ochiladi.",
  inviteClients: "Mijozlarni taklif qilish",
  selectPointToGenerateQR:
    "Yangi mijozlarni RC PAYga ro‘yxatdan o‘tkazish uchun havola va QR-kod yaratish uchun savdo nuqtasini tanlang.",
  invitingtoLoyaltyProgram: "Sodiqlik dasturiga taklif",
  downloadQR: "QR-kodni yuklab olish",
  linkCopied: "Havola nusxalandi",
  share: "Ulashish",
  joinToLoyaltyProgram: "Sodiqlik dasturiga qo‘shiling!",
  receiveDiscountNotifies:
    "Chegirmalar va eksklyuziv aksiyalardan xabardor bo‘ling. Har bir xarid uchun mukofot va ballar bilan to‘lov 99,9% gacha.",
  clientServiceAndAppRcPay:
    "rcpay.ru mijoz xizmati va RC PAY ilovasi – foydali va qulay xarid dunyosidagi yo‘riqchingiz!",
};
